import { IUnit } from '../Unit/Unit-types';

export const ACTION_ATTACK = 'attack';
export const ACTION_BOLSTER = 'bolster';
export const ACTION_CLAIM_INITIATIVE = 'claim_initiative';
export const ACTION_CONTROL = 'control';
export const ACTION_DEPLOY = 'deploy';
export const ACTION_MOVE = 'move';
export const ACTION_PASS = 'pass';
export const ACTION_RECRUIT = 'recruit';
export const ACTION_TACTIC = 'tactic';
export const ACTION_REMOVE = 'remove';
export const ACTION_RESUPPLY = 'resupply';

export interface IActionOption {
    value: string;
    label: string;
}

export interface IAction {
    bishopRecruit: boolean;
    decreeId?: number;
    description?: string;
    fortId?: number;
    friendlyUnitId?: number;
    friendlyUnitIds?: number[];
    label: string;
    opponentUnitId?: number;
    options?: IActionOption[];
    secondaryActionId: number;
    targetPositions?: string[];
    type: string;
    unitId?: number;
}

export interface IActionsResponse {
    actions: IAction[];
    hash: string;
}

export interface IActionsState {
    state: {
        actionModal: IAction | null;
        actions: IAction[];
        activeDecree: string | null;
        activeDecreeId: number | null;
        bishopRecruit: boolean;
        decidingPlayerId: number | null;
		flipLongboat: boolean;
        fortId: number | null;
        friendlyUnitId: number | null;
        hash: string | null;
        opponentUnitId: IUnit | null;
        optionValue: string | null;
        lastActionTime: string | null;
        removableUnitIds: number[];
        resupplyUnitIds: number[];
        selectableUnitIds: number[];
        selectedPosition: string | null;
        selectedUnitActions: IAction[];
        selectedUnitId: number | null;
		showTargetsModal: boolean;
        submitting: boolean;
    },
    mutations: {

    },
    actions: {

    },
}
